import { render } from "./DonateUs.vue?vue&type=template&id=dee8130c&scoped=true"
import script from "./DonateUs.vue?vue&type=script&lang=js"
export * from "./DonateUs.vue?vue&type=script&lang=js"

import "./DonateUs.vue?vue&type=style&index=0&id=dee8130c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee8130c"]])

export default __exports__